var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 120 120",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#9FD8DF;}\r\n\t.st1{opacity:0.1;}\r\n\t.st2{fill:#FF7171;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.9,29.8L35.8,18.9c-5.3-2.3-11.4,0.6-13,6.2l-7.2,26.4c-0.4,1.6-0.3,3.2,0.4,4.7l21.6,45.2   c1.2,2.6,4.3,3.6,6.9,2.4l39-18.7c2.6-1.2,3.6-4.3,2.4-6.9L64.3,33C63.6,31.6,62.4,30.4,60.9,29.8z M38.3,40.6   c-2.9,1.4-6.3,0.2-7.7-2.7c-1.4-2.9-0.2-6.3,2.7-7.7s6.3-0.2,7.7,2.7C42.4,35.8,41.1,39.3,38.3,40.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8,82.6l-39,18.7c-2.6,1.2-5.6,0.1-6.9-2.4L17.3,53.7c-0.7-1.5-0.8-3.1-0.4-4.7l7.2-26.4c0.1-0.2,0.1-0.4,0.2-0.6    c-0.7,0.9-1.2,1.9-1.5,3.1l-7.2,26.4c-0.4,1.6-0.3,3.2,0.4,4.7l21.6,45.2c1.2,2.6,4.3,3.6,6.9,2.4l39-18.7    c1.5-0.7,2.5-2.1,2.8-3.6C85.9,81.9,85.4,82.3,84.8,82.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.7,15.9l-26.6,6.4c-5.6,1.4-8.7,7.4-6.6,12.7l10.1,25.5c0.6,1.5,1.7,2.7,3.1,3.5l44.5,23.1   c2.5,1.3,5.6,0.3,6.9-2.2l19.9-38.4c1.3-2.5,0.3-5.6-2.2-6.9L57.4,16.5C55.9,15.7,54.3,15.5,52.7,15.9z M41.2,38.2   c-1.5,2.8-5,3.9-7.8,2.5s-3.9-5-2.5-7.8c1.5-2.8,5-3.9,7.8-2.5C41.5,31.9,42.7,35.4,41.2,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.7,30.4c2.8,1.5,4,5,2.5,7.8c-0.8,1.5-2.1,2.5-3.7,2.9c0.9-0.5,1.7-1.3,2.2-2.3c1.5-2.8,0.4-6.3-2.5-7.8   c-1.3-0.7-2.8-0.8-4.1-0.5C34.8,29.6,36.9,29.5,38.7,30.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8,81.7c-1.3,2.5-4.4,3.5-6.9,2.2L33.4,60.8c-1.4-0.7-2.6-2-3.1-3.5L20.1,31.9c-0.5-1.3-0.7-2.6-0.7-3.8    c-0.8,2.2-0.9,4.6,0,7l10.1,25.5c0.6,1.5,1.7,2.7,3.1,3.5l44.5,23.1c2.5,1.3,5.6,0.3,6.9-2.2l19.9-38.4c0.5-0.9,0.7-2,0.5-3    L84.8,81.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.7,64l44.5,23.1c0.4,0.2,0.8,0.4,1.2,0.4l-1.9,0.9c-0.6-0.1-1.3-0.2-1.9-0.6L30.2,64.8   c-1.4-0.7-2.5-2-3.1-3.5l-8.4-21.1l1.2-4.2l9.7,24.5C30.2,62,31.3,63.3,32.7,64z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/product-icon.568efbcff88f746eb15b58ed45d0ad67.svg";
export { ForwardRef as ReactComponent };